export const defaultScopeId = "v3.project";
export const contextKey = "project";

export const SUBSCRIBE = "PROJECT/WORKFLOW_STATE/SUBSCRIBE";
export const UNSUBSCRIBE = "PROJECT/WORKFLOW_STATE/UNSUBSCRIBE";
export const LOAD_SUCCEEDED = "PROJECT/WORKFLOW_STATE/LOAD_SUCCEEDED";
export const LOAD_FAILED = "PROJECT/WORKFLOW_STATE/LOAD_FAILED";
export const LOAD_REQUESTED = "PROJECT/WORKFLOW_STATE/LOAD_REQUESTED";
export const UPDATE_REQUESTED = "PROJECT/WORKFLOW_STATE/UPDATE_REQUESTED";
export const UPDATE_SUCCEEDED = "PROJECT/WORKFLOW_STATE/UPDATE_SUCCEEDED";
export const UPDATE_FAILED = "PROJECT/WORKFLOW_STATE/UPDATE_FAILED";
export const PROGRESS_REQUESTED = "PROJECT/WORKFLOW_STATE/PROGRESS_REQUESTED";
export const PROGRESS_SUCCEEDED = "PROJECT/WORKFLOW_STATE/PROGRESS_SUCCEEDED";
export const PROGRESS_FAILED = "PROJECT/WORKFLOW_STATE/PROGRESS_FAILED";
export const UPDATE_ASSIGNEES_REQUESTED = "PROJECT/WORKFLOW_STATE/UPDATE_ASSIGNEES_REQUESTED";
export const UPDATE_ASSIGNEES_SUCCEEDED = "PROJECT/WORKFLOW_STATE/UPDATE_ASSIGNEES_SUCCEEDED";
export const UPDATE_ASSIGNEES_FAILED = "PROJECT/WORKFLOW_STATE/UPDATE_ASSIGNEES_FAILED";

export const projectDefaultState = () => ({
    errors: [],
    groups: [],
    hasInitialData: false,
    loading: 0,
    removing: 0,
    subscriptions: 0,
    updating: 0,
    users: [],
    workflowState: {}
});

// eslint-disable-next-line complexity, max-statements
export default (
    state = projectDefaultState(),
    { type, data }
) => {
    switch (type) {
    case SUBSCRIBE: {
        ++state.subscriptions;
        return state;
    }
    case UNSUBSCRIBE: {
        --state.subscriptions;
        return state;
    }
    case LOAD_REQUESTED: {
        ++state.loading;
        state.workflowState.loading = true;
        return state;
    }
    case LOAD_FAILED: {
        --state.loading;
        const { error } = data;
        state.workflowState.loading = false;
        state.workflowState.error = error;
        state.errors.push({ error, type });
        return state;
    }
    case LOAD_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        Object.assign(
            state.workflowState,
            data,
            {
                loading: false,
            }
        );
        return state;
    }
    case PROGRESS_SUCCEEDED:
    case UPDATE_ASSIGNEES_SUCCEEDED:
    case UPDATE_SUCCEEDED: {
        Object.assign(
            state.workflowState,
            data,
            {
                updating: false,
            }
        );
        --state.updating;
        return state;
    }
    case PROGRESS_REQUESTED:
    case UPDATE_ASSIGNEES_REQUESTED:
    case UPDATE_REQUESTED: {
        state.workflowState.updating = true;
        ++state.updating;
        return state;
    }
    case PROGRESS_FAILED:
    case UPDATE_ASSIGNEES_FAILED:
    case UPDATE_FAILED: {
        const { error } = data;
        state.workflowState.updating = false;
        state.workflowState.error = error;
        state.errors.push({ error, type });
        state.lastError = error;
        --state.updating;
        return state;
    }
    default:
        return state;
    }
};

export const subscribeToWorkflowState = ({ entityId, entityType }) => ({ type: SUBSCRIBE, data: { entityId, entityType } });
export const unsubscribeFromWorkflowState = ({ entityId, entityType }) => ({ type: UNSUBSCRIBE, data: { entityId, entityType } });

export const successLoadWorkflowState = data => ({ type: LOAD_SUCCEEDED, data });
export const failLoadWorkflowState = data => ({ type: LOAD_FAILED, data });
export const requestLoadWorkflowState = () => ({ type: LOAD_REQUESTED });

export const requestUpdateWorkflowState = (data, resolve, reject) => ({ type: UPDATE_REQUESTED, data, resolve, reject });
export const succeedUpdateWorkflowState = data => ({ type: UPDATE_SUCCEEDED, data });
export const failUpdateWorkflowState = data => ({ type: UPDATE_FAILED, data });

export const requestProgressWorkflowState = (data, resolve, reject) => ({ type: PROGRESS_REQUESTED, data, resolve, reject });
export const succeedProgressWorkflowState = data => ({ type: PROGRESS_SUCCEEDED, data });
export const failProgressWorkflowState = data => ({ type: PROGRESS_FAILED, data });

export const requestUpdateWorkflowStateAssignees = (data, resolve, reject) => ({ type: UPDATE_ASSIGNEES_REQUESTED, data, resolve, reject });
export const succeedUpdateWorkflowStateAssignees = data => ({ type: UPDATE_ASSIGNEES_SUCCEEDED, data });
export const failUpdateWorkflowStateAssignees = data => ({ type: UPDATE_ASSIGNEES_FAILED, data });

